import AbstractCanvasTransformTool from "ui/canvas/transforms/AbstractCanvasTransformTool";
import {SCENE_FRAMES} from "ui/config";

export default class CanvasRotate extends AbstractCanvasTransformTool {
	/**
	 * @param {number} angleFrom
	 * @param {number} angleTo
	 */
	constructor(angleFrom, angleTo) {
		super();
		this._angleFrom = angleFrom;
		this._angleTo = angleTo;
		this._angleByFrames = [];
	}

	/**
	 * @inheritDoc
	 */
	_isNeedKeyframesForSelection(fromFrame, toFrame) {
		return fromFrame !== toFrame && this._angleFrom !== this._angleTo;
	}

	/**
	 * @inheritDoc
	 */
	async _prepare(layer, fromFrame, toFrame) {
		const len = toFrame - fromFrame;
		let angle, angleStep;

		this._angleByFrames = new Array(SCENE_FRAMES).fill(0);

		if (len === 0) {
			angleStep = 0;
			angle = this._angleFrom;
		} else if (this._angleFrom === this._angleTo) {
			angleStep = 0;
			angle = this._angleFrom;
		} else {
			angleStep = (this._angleTo - this._angleFrom) / len;
			angle = this._angleFrom;
		}

		for (let i = fromFrame; i <= toFrame; i++) {
			this._angleByFrames[i] = angle;
			angle += angleStep;
		}
	}

	/**
	 * @inheritDoc
	 */
	_transformImage(ctx, mat, frameIndex) {
		mat.rotate(this._angleByFrames[frameIndex]);
	}
}
